
<div class="rfp-ratings-carousel-slide">
  <slot></slot>
</div>
